import { render, staticRenderFns } from "./header-primary.vue?vue&type=template&id=23d6eb2a&scoped=true"
import script from "./header-primary.vue?vue&type=script&lang=js"
export * from "./header-primary.vue?vue&type=script&lang=js"
import style0 from "./header-primary.vue?vue&type=style&index=0&id=23d6eb2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6eb2a",
  null
  
)

export default component.exports